import {FC, useState} from 'react'
import {Button, ButtonGroup, Card, Container, Spinner} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {
  useSmppAdminActivateMutation,
  useSmppAdminChangePasswordMutation,
  useSmppAdminDeactivateMutation,
} from '../../../../../services/cellcast.v2'
import {SmppStatus} from '../../../../../services/cellcast.v2.types'
import {toast} from 'react-toastify'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import ChangePasswordPopup from '../../../../Components/ChangePasswordPopup'
import {useLocation} from 'react-router-dom'

const SmppCard: FC = () => {
  const dispatch = useDispatch()

  const location = useLocation()
  const {userProp} = location.state || ({} as any)

  const userData = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const profileDetailState = userProp?.user ? userProp.user : userData

  const isActive =
    profileDetailState?.smppStatus && profileDetailState?.smppStatus === SmppStatus.Active

  const [activate, {isLoading: activateLoading}] = useSmppAdminActivateMutation()
  const [deactivate, {isLoading: deactivateLoading}] = useSmppAdminDeactivateMutation()
  const [changePassword] = useSmppAdminChangePasswordMutation()

  const [showChangePasswordModel, setShowChangePasswordModal] = useState(false)

  const changeStatusHandler = (status: SmppStatus) => {
    let saveFn = activate
    if (status === SmppStatus.NotActive) {
      saveFn = deactivate
    }

    saveFn(profileDetailState?._id || '').then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
          dispatch(ProfileDetailData(profileDetailState?._id))
        }
      } else if ('error' in res) {
        const resError = res.error as any
        if (resError.data?.message) {
          toast.error(resError.data?.message || '')
        } else {
          toast.error(res?.error.toString() || '')
        }
      }
    })
  }

  const changePasswordHandler = async (
    password: string
  ): Promise<{
    isSuccess: boolean
    message: string
  }> => {
    const result = await changePassword({
      userId: profileDetailState?._id || '',
      password,
    })

    if ('data' in result) {
      if (result.data?.error && Object.keys(result.data?.error).length > 0) {
        return {isSuccess: false, message: result?.data?.message}
      } else {
        return {isSuccess: true, message: result?.data?.message}
      }
    } else if ('error' in result) {
      const resError = result.error as any
      let message = result?.error.toString()
      if (resError.data?.message) {
        message = resError.data?.message || ''
      }
      return {isSuccess: false, message: message}
    }

    return {isSuccess: true, message: ''}
  }

  return (
    <div className={`card mb-6`}>
      <ChangePasswordPopup
        handleClose={() => setShowChangePasswordModal(false)}
        handleSubmit={changePasswordHandler}
        show={showChangePasswordModel}
      />
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Smpp Server</span>
        </h3>
      </div>
      <div className='card-body py-3'>
        {!isActive && (
          <Container style={styles.container}>
            <Button
              variant='primary'
              size='lg'
              onClick={() => changeStatusHandler(SmppStatus.Active)}
            >
              {activateLoading ? <Spinner /> : 'Activate SMPP Account'}
            </Button>
          </Container>
        )}

        {isActive && (
          <>
            <Card.Title>Detail Account</Card.Title>

            <div className='row mb-2 mt-5'>
              <div className='col-md-3'>
                <label>Username </label>
              </div>
              <div className='col-md-6'>{profileDetailState?.smppAuth?.username}</div>
            </div>
            <div className='row mb-2 mb-5'>
              <div className='col-md-3'>
                <label>Status </label>
              </div>
              <div className='col-md-6'>
                <span
                  className={`badge badge-light-${
                    profileDetailState?.smppStatus === SmppStatus.Active ? 'success' : 'danger'
                  }`}
                >
                  {profileDetailState?.smppStatus === SmppStatus.Active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
            <div className='row mb-10'>
              <button
                className='btn btn-sm btn-danger ms-2 col-3'
                onClick={() => changeStatusHandler(SmppStatus.NotActive)}
              >
                {deactivateLoading ? <Spinner size='sm' /> : 'Deactivate'}
              </button>
              <button
                className='btn btn-sm btn-primary ms-2 col-3'
                onClick={() => setShowChangePasswordModal(true)}
              >
                Change Password
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

// Inline styles to center the button
const styles = {
  container: {
    display: 'flex', // Flexbox for centering
    justifyContent: 'center', // Horizontally center
    alignItems: 'center', // Vertically center
    height: '20vh', // Full viewport height
  },
}

export default SmppCard
